import React from "react";
import { GiBoxUnpacking } from "react-icons/gi";
const ShippingCard = ({ heading }) => {
  return (
    <div className="border bg-amber-50 mb-2 md:w-96 w-full p-2 rounded-sm ">
      <input type="radio" name="shippingMethod" className="w-4 h-4" />
      <GiBoxUnpacking className="text-amber-500 inline ml-4 text-5xl" />
      <h1 className="py-2 text-sm font-semibold text-gray-800">{heading}</h1>
      <p className="text-xs text-gray-400 text-medium py-2">
        You store and pack orders a your location. We pick them from above
        address and deliver to to customers. You need a printer and there is a
        fee per shipment.
      </p>
    </div>
  );
};

export default ShippingCard;
